import { atomWithStorage } from 'jotai/utils';

export const selectedUserAtom = atomWithStorage<string>('selected-user', '');
